import { OrganisationTypeRole } from 'app/shared/enums/OrganisationTypeRole.enum';

/**
 * Interface defining a route with its associated roles
 */
export interface RouteRole {
  /**
   * The URI path for the route
   */
  uri: string;

  /**
   * Array of roles that have access to this route
   */
  roles: OrganisationTypeRole[];
}

/**
 * Array of route roles defining access permissions for different routes
 */
export const routeRoles: RouteRole[] = [
  {
    uri: '/dashboard',
    roles: [
      OrganisationTypeRole.CODE_REQUESTER_ALL,
      OrganisationTypeRole.CODE_REQUESTER_AUIS,
      OrganisationTypeRole.NOT_CODE_REQUESTER,
      OrganisationTypeRole.SERVICE_PROVIDER,
      OrganisationTypeRole.STANDARD,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.FIELD_INSPECTOR,
      OrganisationTypeRole.GOV_ADMIN,
      OrganisationTypeRole.ADMIN_DENTSU
    ]
  },
  {
    uri: 'core/users',
    roles: [
      OrganisationTypeRole.ADMIN_DENTSU,
      OrganisationTypeRole.GOV_ADMIN,
      OrganisationTypeRole.CODE_REQUESTER_ALL,
      OrganisationTypeRole.CODE_REQUESTER_AUIS,
      OrganisationTypeRole.NOT_CODE_REQUESTER,
      OrganisationTypeRole.SERVICE_PROVIDER
    ]
  },
  {
    uri: '/configuration/api-access',
    roles: [
      OrganisationTypeRole.ADMIN_DENTSU,
      OrganisationTypeRole.CODE_REQUESTER_ALL,
      OrganisationTypeRole.CODE_REQUESTER_AUIS,
      OrganisationTypeRole.NOT_CODE_REQUESTER,
      OrganisationTypeRole.SERVICE_PROVIDER
    ]
  },
  {
    uri: 'core/bi/landing',
    roles: [
      OrganisationTypeRole.ADMIN_DENTSU,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.GOV_ADMIN
    ]
  },
  {
    uri: 'core/bi/dashboards',
    roles: [
      OrganisationTypeRole.ADMIN_DENTSU,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.GOV_ADMIN
    ]
  },
  {
    uri: 'core/bi/reports',
    roles: [
      OrganisationTypeRole.ADMIN_DENTSU,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.GOV_ADMIN
    ]
  },
  {
    uri: 'core/your-profile',
    roles: [
      OrganisationTypeRole.CODE_REQUESTER_ALL,
      OrganisationTypeRole.CODE_REQUESTER_AUIS,
      OrganisationTypeRole.NOT_CODE_REQUESTER,
      OrganisationTypeRole.SERVICE_PROVIDER,
      OrganisationTypeRole.STANDARD,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.FIELD_INSPECTOR,
      OrganisationTypeRole.GOV_ADMIN,
      OrganisationTypeRole.ADMIN_DENTSU
    ]
  },
  {
    uri: 'legal/terms-and-conditions',
    roles: [
      OrganisationTypeRole.CODE_REQUESTER_ALL,
      OrganisationTypeRole.CODE_REQUESTER_AUIS,
      OrganisationTypeRole.NOT_CODE_REQUESTER,
      OrganisationTypeRole.SERVICE_PROVIDER,
      OrganisationTypeRole.STANDARD,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.FIELD_INSPECTOR,
      OrganisationTypeRole.GOV_ADMIN,
      OrganisationTypeRole.ADMIN_DENTSU
    ]
  },
  {
    uri: 'legal/privacy-policy',
    roles: [
      OrganisationTypeRole.CODE_REQUESTER_ALL,
      OrganisationTypeRole.CODE_REQUESTER_AUIS,
      OrganisationTypeRole.NOT_CODE_REQUESTER,
      OrganisationTypeRole.SERVICE_PROVIDER,
      OrganisationTypeRole.STANDARD,
      OrganisationTypeRole.ADVANCED,
      OrganisationTypeRole.FIELD_INSPECTOR,
      OrganisationTypeRole.GOV_ADMIN,
      OrganisationTypeRole.ADMIN_DENTSU
    ]
  },
];
